import { PanelSettingsService } from '@/backend/market'
import { PanelSettingRepository } from '../../domain/repositories/PanelSettingRepository'
import { PanelSettingModel } from '../models/PanelSettingModel'
import type { PanelSettingEntity } from '../../domain/entities/PanelSettingEntity'
import type { UpdatePanelSettingEntity } from '../../domain/entities/UpdatePanelSettingEntity'
import { UpdatePanelSettingModel } from '../models/UpdatePanelSettingModel'

export class PanelSettingRepositoryImpl implements PanelSettingRepository {
  async getPanelSettings(): Promise<PanelSettingEntity[] | { error: true }> {
    try {
      const response = await PanelSettingsService.getPanelSettingsAdmin()
      const panelSettingModels = response.items?.map((item) => new PanelSettingModel(item))
      return panelSettingModels ?? []
    } catch {
      return { error: true }
    }
  }
  async updatePanelSetting(
    panelSettingData: UpdatePanelSettingEntity
  ): Promise<{ success: true } | { error: true }> {
    const updatePanelSettingModel = new UpdatePanelSettingModel(panelSettingData)
    try {
      await PanelSettingsService.postPanelSettingAdmin({
        requestBody: updatePanelSettingModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
